// API endpoints
export const OVERPASS_URL = 'https://overpass-api.de/api/interpreter';
export const OVERPASS_FALLBACK_URL = 'https://overpass.kumi.systems/api/interpreter';
export const NOMINATIM_URL = 'https://nominatim.openstreetmap.org/search';

// Default location: Pantheon area, Rome, Italy
export const DEFAULT_LAT = 41.8986;
export const DEFAULT_LNG = 12.4769;
export const LOAD_RADIUS_METERS   = 700;
export const WORLD_RELOAD_TRIGGER = 480; // metres from loaded centre → auto-reload

// Road widths by OSM highway tag (full width in meters)
export const ROAD_WIDTHS = {
  motorway:       20,
  motorway_link:  10,
  trunk:          16,
  trunk_link:      8,
  primary:        14,
  primary_link:    7,
  secondary:      12,
  secondary_link:  6,
  tertiary:       10,
  tertiary_link:   5,
  unclassified:    8,
  residential:     8,
  living_street:   6,
  service:         5,
  pedestrian:      6,
  footway:         2.5,
  cycleway:        2,
  path:            2,
  default:         8,
};

// Road colors by type
export const ROAD_COLORS = {
  motorway:         0x556677,
  motorway_link:    0x4a5a6a,
  trunk:            0x556677,
  trunk_link:       0x4a5a6a,
  primary:          0x4a5a6a,
  primary_link:     0x454560,
  secondary:        0x444455,
  secondary_link:   0x404050,
  tertiary:         0x3d3d4d,
  tertiary_link:    0x3a3a48,
  unclassified:     0x3a3a48,
  residential:      0x393944,
  living_street:    0x454040,
  service:          0x383838,
  pedestrian:       0x8a7a68,
  path:             0x9a8868,
  cycleway:         0x625070,
  default:          0x3a3a4a,
};

// Window geometry constants
export const WIN_FLOOR_HEIGHT = 3.5;   // metres per storey (synced with METERS_PER_LEVEL)
export const WIN_WIDTH        = 1.0;   // metres, window opening width
export const WIN_HEIGHT       = 1.3;   // metres, window opening height
export const WIN_SPACING      = 2.4;   // metres between window centre columns
export const WIN_DAY_COLOR    = 0x1a2030;  // dark glass during daytime
export const WIN_NIGHT_COLOR  = 0xffcc66;  // warm amber glow at night

// Building defaults
export const DEFAULT_BUILDING_HEIGHT = 10;   // meters
export const METERS_PER_LEVEL        = 3.5;  // meters per floor

// Car physics constants
export const CAR_ACCEL       = 25;    // m/s²  acceleration
export const CAR_BRAKE       = 40;    // m/s²  braking deceleration
export const CAR_FRICTION    = 0.45;  // velocity damping per second — terminal ≈ ACCEL/FRICTION ≈ 55 m/s
export const CAR_MAX_SPEED   = 55;    // m/s  (~198 km/h) hard cap
export const CAR_MAX_REVERSE = -15;   // m/s
export const STEER_MAX_ANGLE = 0.62;  // radians (~35°) max wheel angle
export const STEER_RATE      = 2.2;   // rad/s  how fast wheels turn
export const STEER_RETURN    = 3.5;   // rad/s  how fast wheels self-center

// Railway widths (half-width in metres)
export const RAILWAY_WIDTHS = {
  rail:         1.25,
  narrow_gauge: 1.05,
  tram:         0.90,
  light_rail:   0.90,
  subway:       1.10,
  default:      1.25,
};
export const RAILWAY_COLOR            = 0x555560;
export const RAILWAY_SLEEPER_COLOR    = 0x6b4020;
export const RAILWAY_SLEEPER_SPACING  = 5;   // metres between sleepers

// Barrier specs (height in metres)
export const BARRIER_SPECS = {
  wall:           { color: 0xa09088, height: 1.4 },
  fence:          { color: 0x606060, height: 1.2 },
  hedge:          { color: 0x3a7030, height: 1.6 },
  retaining_wall: { color: 0x8a8070, height: 2.0 },
  guard_rail:     { color: 0x808090, height: 0.8 },
};

// Bridge geometry
export const BRIDGE_LIFT_BASE       = 6;   // metres of clearance for layer=1
export const BRIDGE_LIFT_PER_LAYER  = 4;   // additional metres per layer above 1
export const BRIDGE_PILLAR_SPACING  = 20;  // metres between support pillars
export const BRIDGE_DECK_COLOR      = 0x888890;
export const BRIDGE_PILLAR_COLOR    = 0x909090;

// Tree geometry
export const TREE_ROW_SPACING       = 9;          // metres between trees on tree_row
export const TREE_DEFAULT_HEIGHT    = 7;           // metres
export const TREE_TRUNK_COLOR       = 0x6b4c2a;
export const TREE_FOLIAGE_DECIDUOUS = 0x3d9a2a;
export const TREE_FOLIAGE_CONIFER   = 0x1a5c10;
export const TREE_FOLIAGE_DEFAULT   = 0x2d7a1f;

// Car collision
export const CAR_RADIUS = 1.8;   // metres — circle used for wall collision

// Airplane mode
export const FLY_ACCEL      = 28;  // m/s²  vertical acceleration
export const FLY_MAX_VSPEED = 22;  // m/s   max vertical speed
export const FLY_DRAG       = 2.5; // vertical drag coefficient

// Traffic
export const TRAFFIC_COUNT     = 20;
export const TRAFFIC_SPEED_MIN = 6;   // m/s (~22 km/h)
export const TRAFFIC_SPEED_MAX = 14;  // m/s (~50 km/h)
export const TRAFFIC_COLOR     = 0x998866;
